import React, { Fragment } from 'react';
import cn from 'classnames';

import { Button, Tooltip } from '@components/common';

import styles from './StepperWithManaging.module.scss';

interface IButtonParams {
	title: string;
	onClick: () => void;
	isDisabled?: boolean;
	disabledDescription?: string;
}

interface IStepParams {
	title: string;
	onClick?: () => void;
	isActive: boolean;
	isAfterSelected?: boolean;
	isBeforeSelected?: boolean;
	shouldBeShown?: boolean;
}

interface IStepperWithManagingProps {
	buttons: IButtonParams[];
	steps: IStepParams[];
}

const StepperWithManaging = ({
	buttons,
	steps,
}: IStepperWithManagingProps) => {
	const amountOfSteps = steps.length;
	const preparedStepItems = steps.map((item, index, array) => {
		return {
			...item,
			isAfterSelected: array[index - 1]?.isActive,
			isBeforeSelected: array[index + 1]?.isActive,
			shouldBeShown: array[index + 1]?.isActive || array[index - 1]?.isActive || item.isActive,
		};
	});

	const getItemClassName = (stepItem: IStepParams, index: number) => {
		return cn(
			styles.stepItem, {
				[styles.stepItemSelected]: stepItem.isActive,
				[styles.stepItemLast]: index === amountOfSteps - 1,
				[styles.stepItemShown]: stepItem.shouldBeShown,
			});
	};

	return (
		<div
			className={styles.stepperWrapper}
			data-testid='stepper-wrapper'
		>
			<div className={styles.managingBlock}>
				{buttons.map((buttonItem) => {
					if (buttonItem.isDisabled) {
						return (
							<Tooltip
								key={buttonItem.title}
								content={buttonItem.disabledDescription}
								placement='top-start'
							>
								<div data-testid={`${buttonItem.title}`}>
									<Button
										className='action-button'
										disabled={buttonItem.isDisabled}
										onClick={buttonItem.onClick}
										text={buttonItem.title}
										withoutBackground
									/>
								</div>
							</Tooltip>
						);
					}

					return (
						<Button
							key={buttonItem.title}
							onClick={buttonItem.onClick}
							secondary
							text={buttonItem.title}
						/>
					);
				})}
			</div>
			<div className={styles.stepItemTextRight}></div>
			{preparedStepItems.map((stepItem, index) => (
				<Fragment key={stepItem.title}>
					{!stepItem.shouldBeShown ? (
						<Tooltip
							content={stepItem.title}
							placement='top-start'
						>
							<div className={styles.unshownItem}>
								<div className={cn(styles.stepItemTextLeft, {
									[styles.stepItemSelected]: stepItem.isActive,
								})} />
								<div className={getItemClassName(stepItem, index)} />
								{amountOfSteps - 1 !== index && <div className={styles.stepItemTextRight}></div>}
							</div>
						</Tooltip>
					) : (
						<>
							<div className={cn(styles.stepItemTextLeft, {
								[styles.stepItemSelected]: stepItem.isActive,
							})} />
							<div
								className={getItemClassName(stepItem, index)}
								data-testid={stepItem.title}
							>
								{stepItem.title}
							</div>
							{amountOfSteps - 1 !== index && <div className={styles.stepItemTextRight}></div>}
						</>
					)}
				</Fragment>
			))}
		</div>
	);
};

export default StepperWithManaging;
